var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"flex-grow d-flex flex-col w-full",attrs:{"data-test":"image-content"}},[_c('img',{attrs:{"src":_vm.url,"alt":_vm.altText}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }